module.exports = __webpack_public_path__ + "img/ico-edit2.f377dd64.svg";